import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createInstructor } from "store/slices/instructorsSlice";
import { closeModal } from "store/slices/modalsSlice";
import { getSchools } from "store/slices/schoolsSlice";
import InstructorForm from "./instructor-form";

const NewInstructorModal = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const { loading } = useSelector((state) => state?.instructors);
  const { schools } = useSelector((state) => state?.schools);
  const open = isModalOpen && modalType === "new_instructor";

  const { userData } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (open && userData?._id) dispatch(getSchools(userData?._id));
  }, [dispatch, open, userData?._id]);

  const onSubmit = async (values) => {
    try {
      // Formatage des données selon les attentes du backend
      const formData = new FormData();

      const appendIfDefined = (key, value) => {
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      };

      // Ajouter les champs textuels
      formData?.append("fullName", values?.fullName);
      formData?.append("email", values?.email);
      formData?.append("phoneNumber", values?.phoneNumber);
      formData?.append("wilaya", values?.wilaya);
      formData?.append("schoolId", values?.schoolId);
      formData?.append("password", values?.password);
      formData?.append("confirmPassword", values?.confirmPassword);
      appendIfDefined("identityCardNumber", values?.identityCardNumber);
      appendIfDefined("title", values?.title);
      appendIfDefined("speciality", values?.speciality);
      appendIfDefined("profile", values?.profile);
      appendIfDefined("shortDescription", values?.shortDescription);
      appendIfDefined('isFeatured', values?.isFeutured);
      // Formater la date de naissance au format YYYY-MM-DD
      if (values?.birthDate) {
        formData?.append(
          "birthDate",
          dayjs(values?.birthDate)?.format("YYYY-MM-DD")
        );
      }

      // Ajouter les fichiers
      if (values?.image && values?.image[0]?.originFileObj) {
        formData?.append("instructorImg", values?.image[0]?.originFileObj);
      }

      if (values?.cv && values?.cv[0]?.originFileObj) {
        formData?.append("cv", values?.cv[0]?.originFileObj);
      }

      await dispatch(createInstructor(formData))?.unwrap();

      notification?.success({
        message: t("instructors.crud.form.success"),
        description: t("instructors.crud.form.success.description"),
      });

      onClose();
    } catch (error) {
      notification?.error({
        message: t("instructors.crud.form.error.failed"),
        description:
          error?.message || t("instructors.crud.form.error.description"),
        duration: 5,
      });
    }
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={
        <h4 style={{ textAlign: "center" }}>{t("instructors.crud.new")}</h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("instructors.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="instructor_form"
          disabled={loading}
        >
          {t("instructors.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <InstructorForm
        form={form}
        onSubmit={onSubmit}
        schools={schools}
        isEditing={false}
      />
    </Modal>
  );
};

export default NewInstructorModal;
